// Order references inside chat messages.
//
// We don't add a JSONB column to `messages` for this — instead, the order
// metadata is encoded inline in `content` with a recognizable sentinel prefix.
// Renderers detect the prefix and draw a clickable order card; everything
// else in the codebase keeps treating the message as plain text.
//
// Wire format:  __KAPIO_ORDER_REF__::{json}
// JSON shape:   { sub_order_id, sub_number, parent_order_number, image, status }
//
// The sentinel is intentionally unlikely to collide with anything a buyer or
// seller would type, and keeps the schema migration-free.

const SENTINEL = "__KAPIO_ORDER_REF__::";

export function encodeOrderRef(ref) {
  return SENTINEL + JSON.stringify(ref);
}

export function decodeOrderRef(content) {
  if (typeof content !== "string" || !content.startsWith(SENTINEL)) return null;
  try {
    const parsed = JSON.parse(content.slice(SENTINEL.length));
    if (!parsed || !parsed.sub_order_id) return null;
    return parsed;
  } catch {
    return null;
  }
}

// Short, human-readable preview used for last_message_preview on conversations.
export function orderRefPreview(ref) {
  return `📦 Order ${ref.sub_number || ref.parent_order_number || ref.sub_order_id?.slice(0, 6) || ""}`.trim();
}
